// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__irKO3","col":"CardReaderDesc_col__1mImb","label":"CardReaderDesc_label__1gwLI"};